import { Trans } from "react-i18next";import { useTranslation } from "react-i18next";
import { LANGUAGE_STORAGE_KEY } from "../../i18n";

export function LanguageSelector() {
  const { i18n, t } = useTranslation();
  const language = ["hi", "te", "kn"].includes(i18n.resolvedLanguage) ?
  i18n.resolvedLanguage :
  "en";

  const changeLanguage = (event) => {
    const nextLanguage = event.target.value;
    i18n.changeLanguage(nextLanguage);
    localStorage.setItem(LANGUAGE_STORAGE_KEY, nextLanguage);
  };

  return (
    <label className="block">
      <span className="sr-only">{t("language.label")}</span>
      <select
        value={language}
        onChange={changeLanguage}
        className="h-9 rounded-lg border border-white/30 bg-white/10 px-2 text-sm font-medium text-white outline-none hover:bg-white/20 focus:ring-2 focus:ring-white/70"
        aria-label={t("language.label")}>
        
        <option value="en" className="bg-white text-slate-900"><Trans i18nKey="layout.en" /></option>
        <option value="hi" className="bg-white text-slate-900">हि</option>
        <option value="te" className="bg-white text-slate-900">తె</option>
        <option value="kn" className="bg-white text-slate-900">ಕ</option>
      </select>
    </label>);

}
